function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * ## Usage
 *
 * ```
 * const MyComp = ({ foo, ...restProps }) => {
 *  return (
 *    <div bar={foo} {...filterA11YProps(restProps)}>
 *      // ...
 *    </div>
 *  );
 * }
 * ```jsx
 */
var filterObj = function filterObj(obj, includeKey) {
  return Object.keys(obj).reduce(function (map, key) {
    return includeKey(key) ? _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, obj[key])) : map;
  }, {});
};

var filterA11YProps = function filterA11YProps(props) {
  return filterObj(props, function (name) {
    return ['role', 'tabIndex'].includes(name) || name.startsWith('aria');
  });
};

export default filterA11YProps;